var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinancial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 125.49,
    height: 111.13,
    viewBox: "0 0 125.49 111.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.194,
    y1: 0.21,
    x2: 1.22,
    y2: 1.46,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55a4ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_awesome-comments-dollar",
    x: 0,
    y: 0,
    width: 125.49,
    height: 111.13,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Icon_awesome-comments-dollar)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-comments-dollar-2",
    "data-name": "Icon awesome-comments-dollar",
    d: "M46.549,20.154c0-9.888-10.42-17.9-23.275-17.9S0,10.265,0,20.154A15.194,15.194,0,0,0,4.249,30.446a25.047,25.047,0,0,1-4,6.1A.895.895,0,0,0,.9,38.057a19.689,19.689,0,0,0,9.929-2.8,28.4,28.4,0,0,0,12.451,2.8C36.129,38.057,46.549,30.042,46.549,20.154ZM21.484,30.9V29.073a6.407,6.407,0,0,1-3.51-1.27.9.9,0,0,1-.064-1.358l1.315-1.254a.918.918,0,0,1,1.134-.082,2.694,2.694,0,0,0,1.435.416h3.145a1.407,1.407,0,0,0,1.32-1.476,1.461,1.461,0,0,0-.981-1.424l-5.035-1.511a5.064,5.064,0,0,1-3.534-4.855,4.983,4.983,0,0,1,4.775-5.043v-1.8a.9.9,0,0,1,.9-.9h1.79a.9.9,0,0,1,.9.9v1.823a6.4,6.4,0,0,1,3.51,1.27.9.9,0,0,1,.064,1.358l-1.315,1.254a.918.918,0,0,1-1.134.082,2.684,2.684,0,0,0-1.435-.416H21.61a1.407,1.407,0,0,0-1.32,1.476,1.461,1.461,0,0,0,.981,1.424l5.035,1.511a5.064,5.064,0,0,1,3.534,4.855,4.982,4.982,0,0,1-4.775,5.043v1.8a.9.9,0,0,1-.9.9h-1.79A.9.9,0,0,1,21.484,30.9ZM60.2,44.77a15.189,15.189,0,0,0,4.251-10.293c0-7.49-5.985-13.9-14.472-16.569a17.363,17.363,0,0,1,.149,2.246C50.13,32,38.083,41.638,23.275,41.638a33.372,33.372,0,0,1-3.55-.21C23.252,47.863,31.529,52.38,41.178,52.38a28.4,28.4,0,0,0,12.451-2.8,19.689,19.689,0,0,0,9.929,2.8.9.9,0,0,0,.648-1.512A24.951,24.951,0,0,1,60.2,44.77Z",
    transform: "translate(25.52 23.25)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancial);
export default __webpack_public_path__ + "static/media/financial.8deb6765e265d6c8f8b1e97c80164c0b.svg";
export { ForwardRef as ReactComponent };